import { UniformSlot } from "@uniformdev/canvas-react";

import {
    ModalLink,
    ModalLinkProps
} from "@/libraries/design/components/modal/src/modal-link";

const UniformModal = (props: ModalLinkProps) => {
    return (
        <ModalLink
            modalTitle={props.modalTitle}
            modalCloseLabel={props.modalCloseLabel}
            ctaText={props.ctaText}
        >
            <UniformSlot name="modalContent" />
        </ModalLink>
    );
};

export default UniformModal;
